import { Grid, Icon } from 'coreOld/elements';

import FilterField from '../FilterField';
import { ClearIcon, FilterWrapper } from './inputGroupStyle';

interface IProps {
  fields: Record<string, any>;
  values?: Record<string, any>;
  onChange?;
  onClear?: () => void;
  individualFields?: boolean;
}

const getIndividualValues = (fields, values) => {
  const fieldValues = {};

  fields.forEach((field) => {
    if (values[field.name]) {
      fieldValues[field.name] = values[field.name];
    }
  });

  return fieldValues;
};

const InputGroupView = ({ fields, values, onChange, onClear, individualFields }: IProps) => {
  const inputGroupsValues = individualFields
    ? getIndividualValues(fields, values)
    : values[fields.name];

  return (
    <FilterWrapper>
      <Grid container spacing={1} style={{ width: 'initial', marginLeft: -15 }}>
        {fields.map((field) => (
          <Grid item key={field.name} xs={12} md={6}>
            <FilterField
              values={values}
              filter={field}
              onChangeFilter={(name, event) => onChange(name, event)}
            />
          </Grid>
        ))}
      </Grid>

      <ClearIcon
        isHidden={!inputGroupsValues || !Object.keys(inputGroupsValues).length}
        onClick={() => onClear()}
      >
        <Icon name={Icon.CLEAR} />
      </ClearIcon>
    </FilterWrapper>
  );
};

export default InputGroupView;
